<template>
  <div class="relative-pull d2-mt-20">
    <el-form class="d2-mt-20 d2-mr-20" ref="searchForm" :model="searchForm" size="small" :label-width="formLabelWidth"
      @submit.native.prevent>
      <el-row>
        <el-col :span="5">
          <el-form-item prop="sort" label="排序">
            <el-select v-model="searchForm.sort" class="w100" @change="handlesearch">
              <el-option v-for="item in sortList" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item prop="Category" label="类型">
            <el-select v-model="searchForm.Category" class="w100" @change="handlesearch">
              <el-option v-for="item in typeList" :key="item.Name" :label="item.Name" :value="item.Name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="关键词">
            <el-input placeholder="请输入标题等关键字搜索" v-model="searchForm.keyWords" clearable
              @keyup.enter.native="handlesearch" class="w100">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label-width="20px">
            <el-button size="small" :loading="loading" type="primary" icon="el-icon-search" @click="handlesearch()">搜索
            </el-button>
            <el-button size="small" icon="el-icon-refresh-left" @click="Reset">重置</el-button>
          </el-form-item>
        </el-col>
        <el-button v-if="checked.name=='职代会代表专线'" type="primary" class="d2-fr publish_btn" icon="el-icon-plus"
          @click="publistHandle">我要发布</el-button>
      </el-row>
    </el-form>
    <el-row class="sec_box d2-mt-10" v-loading="loading">
      <div class="header_box d2-mb-20">
        <span></span>热门
      </div>
      <template v-if="HotList.length != 0">
        <el-col :span="24" v-for="(item,index) in HotList" :key="item.ID+''+index" class="hot_box">
          <div class="hot_list d2-mb-10" @click="listDetialHandle(item)"><img class="d2-mr-5" src="@/assets/img/hot.png"
              width="22px" height="22px" />
            <p style="flex:1;">{{item.Subject}}</p>
            <i :class="
              item.AdminReply && item.AdminReply != ''
                ? 'iconfont iconRepliedNew'
                : 'iconfont iconUnrepliedNew'
            " style="color: #999999; font-size: 28px" />
          </div>
        </el-col>
        <div class="d2-clearfix"></div>
      </template>
      <template v-else>
        <el-empty class="auto"></el-empty>
      </template>
      <div class="header_box d2-mb-20">
        <span></span>热点列表
      </div>
      <template v-if="ListData1.length != 0">
        <el-col :span="24" v-for="(item,index) in ListData1" :key="item._CONFIG_ID">
          <div class="box-shadow d2-mb-15">
            <div class="hot_item_header" @click="listDetialHandle(item)">
              <img
                :src="item.avatarUrl && item.avatarUrl != '' ? item.avatarUrl.indexOf('http')!=-1?item.avatarUrl:$apiUrl + item.avatarUrl : require('@/assets/img/avatarUrl.png')">
              <div class="d2-ml-10">
                <div class="hot_item_header_name">
                  <p>{{item.MemberName}} <span>/ ({{item.Category}})</span></p>
                  <p class="align-right">
                    <template v-if="!item.isRead && item.isRead!=false"></template>
                    <template v-else>
                      <span :class="['list_item_circle', item.isRead ? '' : 'active']"></span>
                    </template>
                  </p>
                </div>
                <div class="hot_item_header_depart">
                  <p>{{item.WorkUnit}} / {{item.City}}</p>
                  <p class="align-right">
                    <span class="d2-ml-10">
                      <d2-icon name="commenting-o" class="icon d2-mr-5" />{{item.CommentCount}}
                    </span>
                    <span class="d2-ml-10" @click.stop="getAgree(index,item.ID,item._TEMPLATE_ID,item.agreeType)">
                      <d2-icon :name="item.agreeType == 0 ? 'heart-o' : 'heart'" class="icon d2-mr-5" />
                      {{item.AgreeCount}}
                    </span>
                    <span class="d2-ml-10">
                      <d2-icon name="eye" class="icon d2-mr-5" />{{item.ReadCount}}
                    </span>
                  </p>
                </div>
                <div class="hot_item_header_depart">
                  <p>{{item.StationName}} / {{item.Depart}}</p>
                  <p class="align-right"><span>
                      <d2-icon name="clock-o" class="icon d2-mr-5" />{{item.CreateTime}}</span></p>
                </div>
              </div>
            </div>
            <div class="hot_item_title" @click="listDetialHandle(item)">
              {{item.Subject}}
            </div>
            <div class="hot_item_con" @click="listDetialHandle(item)">{{item.Content}}</div>
            <div v-if="item.Materials" class="hot_item_imgbox">
              <el-image class="hot_item_imgsection" v-for="obj in item.fileIds" :key="obj" :src="obj"
                :preview-src-list="item.fileIds">
              </el-image>
            </div>
          </div>
        </el-col>
        <el-col :span="24" class="align-center mt-20 d2-mb-20">
          <span class="no_more">没有更多了~</span>
        </el-col>
      </template>
      <template v-else>
        <el-empty class="auto"></el-empty>
      </template>
    </el-row>
    <edit-publish :publish='publish' v-model="editPublishVisible" @submit='getPublishData' />
  </div>
</template>

<script>
  import editPublish from "./editPublish";
  import * as indexService from "@/api/sys/index";
  import _ from "lodash";
  export default {
    name: "listLine",
    components: {
      editPublish,
    },
    data() {
      return {
        searchForm: {
          keyWords: "",
          Category: '',
          sort: '',
        },
        HotList: [],
        sortList: [{
            text: "默认",
            value: " CreateTime DESC "
          },
          {
            text: "阅读量",
            value: " ReadCount DESC ,CreateTime DESC "
          },
          {
            text: "点赞量",
            value: " AgreeCount DESC ,CreateTime DESC "
          },
          {
            text: "回复量",
            value: " CommentCount DESC ,CreateTime DESC "
          },
        ],
        typeList: [],
        formLabelWidth: "100px",
        ListData1: [],
        editPublishVisible: false,
        publish: {}
      };
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      checked: {
        type: Object,
        required: false,
        default: {},
      },
      ListData: {
        type: Array,
        required: false,
        default: () => [],
      },
      readData: {
        type: Array,
        required: false,
        default: () => [],
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    created() {
      this.getSearchData();
      this.getHotCongress();
      this.setValue();
    },
    watch: {
      readData(val) {
        this.setValue(val)
      }
    },
    mounted() {},
    methods: {
      setValue(val) {
        let array = val ? val : this.readData
        this.ListData1 = array.map(v => {
          if (v.Materials) {
            let Materials = v.Materials.split(',')
            Materials = Materials.map(n => {
              if (n.indexOf('.jpg') != -1 || n.indexOf('.jpeg') != -1 || n.indexOf('.png') != -1 || n.indexOf(
                  '.gif') != -1) {
                if (n.indexOf('https') == -1) {
                  return this.$apiUrl + '' + n
                } else {
                  return n
                }
              } else {
                return
              }

            })
            let newArrary = JSON.parse(JSON.stringify(Materials));
            newArrary = _.compact(newArrary)
            if (Materials.length != 0) {
              return {
                ...v,
                fileIds: newArrary.length == 0 ? [] : Materials
              }
            }
          } else {
            return {
              ...v
            }
          }
        });
      },
      getHotCongress() {
        let parmas = {
          filter: [{key:"ComeFrom",value:"PC",sqlOperator:"notEqual"}],
          limit: 3,
          orderby:[{columnName:"IsTop",sortType:"desc"},{columnName:"ReadCount",sortType:"desc"}],
          shortTitle: "职代会热点视图",
          start: 1,
        }
        indexService.GetDiseaseType(parmas).then((data) => {
          this.HotList = data.data
        });
      },
      getSearchData() {
        let parmas = {
          limit: 999,
          shortTitle: "热点分类视图",
          start: 1
        }
        indexService.GetSearchList(parmas).then((data) => {
          this.typeList = data.data;
        });

      },
      handlesearch: _.debounce(
        function (search) {
          this.pageIndex = 0;
          this.$emit("search", this.pageIndex, this.searchForm);
        },
        1000, {
          leading: true,
          trailing: false,
        }
      ),
      Reset() {
        this.searchForm.keyWords = ''
        this.searchForm.Category = ''
        this.searchForm.sort = ''
        this.pageIndex = 0;
        this.$emit("search", this.pageIndex, this.searchForm);
      },
      listDetialHandle(item) {
        console.log(item)
        if (!item.isRead) {
          let configID = {
            configID: item._CONFIG_ID,
          };
          indexService.IsReadListData(configID).then((data) => {});
        }
        this.$router.push({
          path: "webView",
          query: {
            code: "comment",
            shortTitle: "职代会热点",
            detailed: false,
            dataId: item.ID,
            fiter: "",
            routeFrom: this.checked.name
          },
        });
      },
      // 点赞
      getAgree(index, ID, TID, agreeType) {
        let query = {
          DataId: ID,
          TemplateId: TID,
        };
        indexService.getAgreeData(query).then((data) => {
          if (data.success && agreeType == 0) {
            this.$message.success("点赞成功！");
          } else {
            this.$message.warning("取消点赞！");
          }
          this.GetDZCount(index, ID, TID);
        });
      },
      GetDZCount: function (index, ID, TID) {
        let _this = this
        let prams = {
          DataId: ID,
          TemplateId: TID,
        };
        indexService.GetDZCount(prams).then((data) => {
          this.ListData1[index].agreeType = data.agreeType;
          this.ListData1[index].count = data.count;
          this.ListData1[index].AgreeCount = data.count;
          this.$forceUpdate();
        }).catch((e) => {});

      },
      publistHandle() {
        this.editPublishVisible = true;
        this.publish = {}
      },
      getPublishData() {
        this.Reset();
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";
  @import "~@/assets/iconfont/iconfont.css";

  /deep/ .el-dialog__body {
    padding: 5px 20px;
  }

  .el-table th.el-table__cell>.cell {
    color: #333;
  }
</style>